import React from "react"

const Section = ({ children, className, ...additionalProps }) => (
  <section className={`${className ?? ""} container`} {...additionalProps}>
    {children}
  </section>
)

export default Section
